<app-progress-spinner *ngIf="loading"></app-progress-spinner>

<!-- Header -->
<div class="col-md-12 col-lg-12" style="background-color: #CF4B00; margin-top: 0; height: 35px; margin-bottom: 10px;">
  <label class="label-headercolor label-text" style="padding-bottom: 0 !important;">
    Select a different Project for your configuration
  </label>
</div>

<!-- Body -->
<form [formGroup]="form" class="container">
  <!-- Row: Configuration (read-only to align visually with inputs) -->
  <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
    <div class="col-md-2 col-lg-2">
      <label>Configuration</label>
    </div>
    <div class="col-md-10 col-lg-10">
      <div class="textfield js-textfield textfield-with-prefix"
        style="margin-bottom: -1.66667rem !important; width: 300%;">
        <input type="text" aria-label="Selected configuration" class="form-control textfield__input"
          [value]="displayConfiguration" readonly />
      </div>
    </div>
  </div>

  <!-- Row: Target Project (required select) -->
  <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
    <div class="col-md-2 col-lg-2">
      <label>Target Project<span class="asterisk_input">*</span></label>
    </div>

    <div class="col-md-10 col-lg-10">
      <div class="project-select-wrap">
        <mat-select id="targetProject" class="form-control project-select-dropdown" aria-label="Target Project"
          formControlName="projectId" (selectionChange)="onProjectChange($event.value)"
          [disabled]="loading || !availableProjects?.length" placeholder="Please select">
          <mat-option disabled class="search-box-option">
            <input type="text" [formControl]="searchControl" placeholder="Search projects..."
              class="project-search-input" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
          </mat-option>

          <!-- Show message if no results -->
          <mat-option *ngIf="filteredProjects?.length === 0" disabled>
            No projects found
          </mat-option>

          <mat-option *ngFor="let p of filteredProjects" [value]="p.ProjectId"
            [title]="'ID ' + p.ProjectId + ' - ' + p.ProjectTitle">
            {{ 'ID ' + p.ProjectId + ' - ' + p.ProjectTitle }}
          </mat-option>
        </mat-select>
      </div>

      <!-- Simple validation message -->
      <!-- <div *ngIf="form.get('projectId')?.touched && form.get('projectId')?.hasError('required')"
        style="color: #d32f2f; font-size: 0.75rem; margin-top: 4px;">
        Target project is required
      </div> -->
    </div>
  </div>
</form>

<!-- Actions -->
<mat-dialog-actions align="end" style="margin-top: 20px; margin-right: 20px">
  <button class="button button--small" mat-dialog-close [disabled]="loading">
    Cancel
  </button>&nbsp;
  <button class="button button--small" cdkFocusInitial (click)="onForwardClick($event)"
    [disabled]="form.invalid || loading">
    <span *ngIf="!loading">Forward</span>
  </button>
</mat-dialog-actions>